/**
 * Mirror of the Cloud Function's `mapAnswerContext` (in
 * `elementor-cx-help-center-cf/events.js`). We rebuild the same shape on
 * the client so the feedback POST can echo back to the CF exactly what
 * the original query event carried — no schema drift, no mystery
 * differences in dashboards.
 *
 * Order matters and matches the CF: citations → videos → related_articles.
 * Items missing either `link` or `title` are dropped (same defensive
 * filter the CF applies).
 *
 * Caps the result at 30 entries to align with the CF feedback handler's
 * `MAX_ANSWER_CONTEXT`. Live responses today max out around 15 entries
 * (3 citations + up to 10 videos + ~2 related); the cap is headroom.
 * Anything beyond 30 is truncated client-side rather than letting the
 * CF reject the whole feedback POST.
 */

const MAX_ENTRIES = 30;

export function buildAnswerContext(response) {
  const out = [];

  for (const c of response?.citations || []) {
    if (c?.link && c?.title) {
      out.push({ context_type: 'CITATION', url: c.link, title: c.title });
    }
  }
  for (const v of response?.videos || []) {
    if (v?.link && v?.title) {
      out.push({ context_type: 'VIDEO', url: v.link, title: v.title });
    }
  }
  for (const a of response?.related_articles || []) {
    if (a?.link && a?.title) {
      out.push({ context_type: 'RELATED_ARTICLE', url: a.link, title: a.title });
    }
  }

  return out.slice(0, MAX_ENTRIES);
}
